import Breadcrumb from "components/Common/Breadcrumb"
import NewPagination from "components/Common/Newpagination"
import React, { useEffect, useMemo, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Switch } from "antd"
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table"
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap"
import editEventImg from "../../../assets/images/Digital Marketing/editEventImg.jpg"
import { ResizableBox } from "react-resizable"
import Draggable from "react-draggable"
import configure from "configure"
import Swal from "sweetalert2"
import Icon from "../../../assets/images/users/AdminImg.png"
import axios from "axios"
import moment from "moment"
import Loader from "pages/Separate/Loader"
import { fetchNodeData } from "utils/common-fetchData"
import { serviceOption } from "utils/common-options"
// import PortfolioActivityViewer from "./EventTracking"
import UserTracking from "./EventTracking"

function TableContainer({ columns, data, setAccessDenied, setLoading }) {
  const [fixedHeader, setFixedHeader] = useState(false)
  const [fixedContent, setFixedContent] = useState(false)
  const [reportFilter, setReportFilter] = useState(false)
  const navigate = useNavigate()
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 50,
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  useEffect(() => {
    const handleScrollHeader = () => {
      setFixedHeader(window.scrollY > 165)
    }

    const handleScrollContent = () => {
      const scrollThreshold = window.innerHeight * 0.25
      setFixedContent(window.scrollY > scrollThreshold)
    }

    const handleKeydown = e => {
      if (e.key === "Escape") {
        setReportFilter(false)
      }
    }

    window.addEventListener("scroll", handleScrollHeader)
    window.addEventListener("scroll", handleScrollContent)
    window.addEventListener("keydown", handleKeydown)

    return () => {
      window.removeEventListener("scroll", handleScrollHeader)
      window.removeEventListener("scroll", handleScrollContent)
      window.removeEventListener("keydown", handleKeydown)
    }
  }, [])

  return (
    <div>
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <Link
          className="btn btn-save  fix-btn btn-label pe-0"
          onClick={() => navigate(`${configure.appUrl}add-portfolio`)}
        >
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Portfolio</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red  fix-btn btn-label pe-0"
          type="button"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col md={3}>
          <div>
            <select
              className=" form-select"
              style={{ width: "100px" }}
              value={pageSize}
              onChange={e => setPageSize(e.target.value)}
            >
              {[10, 25, 50, 100].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </div>
        </Col>
        <Col md={9} className="d-flex justify-content-end">
          <div className="me-2 d-flex">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className=" form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="text-md-end ">
            <div className="d-flex gap-2">
              <a
                className=" btn btn-save btn-label ms-md-2"
                onClick={() => navigate(`${configure.appUrl}add-portfolio`)}
              >
                <i className="fas fa-plus me-2 label-icon"></i>
                Portfolio
              </a>
              <a
                onClick={() => navigate(-1)}
                className=" btn ms-md-2 btn-red btn-label"
                type="button"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                CANCEL
              </a>
            </div>
          </div>
        </Col>
      </Row>
      <Table className="table table-bordered mt-4 shadow case-study-table1" {...getTableProps()}>
        <thead
          className={`${fixedHeader && page.length >= 10 ? "fix-staffs-headers" : ""
            } fix-staff-headers`}
        >
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`t-col-${index + 1} ${column.className
                    } customShortIcon`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                  {column.isShortIcon && (
                    <span
                      onClick={e => column.getSortByToggleProps().onClick(e)}
                      className="ms-2 cursor-pointer"
                    >
                      <i
                        title="Ascending"
                        className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc
                          ? "text-dark"
                          : ""
                          }`}
                      ></i>
                      <i
                        title="Descending"
                        className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
                          ? "text-dark"
                          : ""
                          }`}
                      ></i>
                    </span>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody className={`fix-staff-headers `} {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr
                className={`row-hover ${row.original.chance ? "bg-orange" : ""
                  }`}
                {...row.getRowProps()}
                key={i}
              >
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      key={index}
                      className={`t-col-${index + 1}`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  )
}

const Portfolio = () => {
  const [datas, setData] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [isEvent, setIsEvent] = useState(false)
  const navigate = useNavigate()
  const [allEvents, setAllEvents] = useState([])
  const [caseStudies, setCaseStudies] = useState([])

  document.title = "Portfolio | Zithas Crm"

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setLoading(true)
    await axios
      .get(`${configure.nodeApi}/portfolio`)
      .then(res => {
        setLoading(false)
        setData(res?.data?.portfolios)
      })
      .catch(e => {
        setLoading(false)
        console.log(e)
      })

    await axios
      .get(`${configure.nodeApi}/case-study`)
      .then(res => {
        setCaseStudies(res?.data?.caseStudy?.map(item => ({
          id: item.id,
          project_name: item.project_name,
          services: item.services,
        })))
      })
      .catch(e => {
        console.log(e)
      })
  }




  const ondelete = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this Portfolio?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#762C99",
      cancelButtonColor: "#BF1E30",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          setLoading(true)
          const res = await axios.delete(`${configure.nodeApi}/portfolio/${id}`)
          if (res?.data?.success) {
            Swal.fire("Deleted!", "The Portfolio has been deleted.", "success")
            fetchData()
          }
        } catch (e) {
          Swal.fire("Error", "Something Went Wrong", "error")
        }
      }
    })
  }

  const handleGenerateLink = generated_link => {
    navigator?.clipboard?.writeText(generated_link)
    Swal.fire("Link Copied!", "", "success")
  }

  const toggleLoading = (loading) => setLoading(loading)
  const onGetEvents = async (id) => {
    const res = await fetchNodeData(toggleLoading, `portfolio/loginAnalytics/${id}`);
    console.log(res)
    if (res?.success) {
      setIsEvent(true)
      setAllEvents(res?.analytics)
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        className: "iv_id",
        Cell: cellProps => (
          <div className="text-center">{cellProps.row.original.id}</div>
        ),
      },
      {
        Header: "Portfolio Name",
        accessor: "portfolio_name",
        className: "",
        Cell: cellProps => {
          return (
            <div className="d-flex align-items-center gap-2">
              <div className="profileImg-box">
                <img
                  src={`${cellProps?.row?.original?.avatar ? `${configure.imgUrl}${cellProps?.row?.original?.avatar}` : Icon}`}
                  alt=""
                  className="assigned-img mx-1"
                  height="20"
                  width="20"
                  title={cellProps?.row?.original.alias_name}
                ></img>
              </div>
              <div>{cellProps?.row?.original?.portfolio_name}</div>
            </div>
          )
        }
      },
      {
        Header: "Projects",
        accessor: "caseStudyIds",
        className: "",
        Cell: cellProps => (
          <div className="text-center">
            {cellProps.row.original.caseStudyIds?.split(",").length}
          </div>
        ),
      },
      {
        Header: "Lead Name",
        accessor: "lead_company_name",
        className: "",
        Cell: cellProps => (
          <div className="text-center">
            {cellProps.row.original.lead_company_name || "-"}
          </div>
        ),
      },
      {
        Header: "Service",
        accessor: "caseStudies", // important: refers to the array in your row data
        className: "",
        Cell: ({ value }) => {
          if (!Array.isArray(value)) return ""

          const uniqueServices = [...new Set(value.map(item => item.services))]
          return uniqueServices.join(", ")
        },
      },
      {
        Header: "Clicks",
        accessor: "case_study_visit_count",
        className: "",
      },
      {
        Header: "Login's",
        accessor: "login_count",
        className: "",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        className: "",
        Cell: cellProps => (
          <div className="text-center">
            {moment(cellProps.row.original.createdAt).format("DD/MM/YYYY")}
          </div>
        ),
      },
      {
        Header: "Status",
        accessor: "active_status",
        className: "",
        Cell: ({ row }) => {
          const [loading, setLoading] = useState(false)
          const [checked, setChecked] = useState(
            row.original.active_status === true
          )

          const handleChange = async checked => {

            Swal.fire({
              title: "Are you sure?",
              text: `You want to ${checked ? 'Activate' : 'Deactivate'} this Portfolio?`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#762C99",
              cancelButtonColor: "#BF1E30",
              confirmButtonText: "Yes, do it!",
            }).then(async result => {
              if (result.isConfirmed) {
                setLoading(true)

                const updatedStatus = checked ? true : false
                try {
                  setLoading(true)
                  const res = await axios.patch(
                    `${configure.nodeApi}/portfolio/${row.original?.id}`, {
                    active_status: updatedStatus
                  }
                  )
                  if (res?.data?.success) {
                    Swal.fire(
                      "Status Updated!",
                      "The Portfolio status has been Updated.",
                      "success"
                    )
                    fetchData()
                    setChecked(checked)

                  }
                } catch (e) {
                  Swal.fire("Error", "Something Went Wrong", "error")
                }

                setLoading(false)
              }
            })

          }

          return (
            <div className="text-center">
              <Switch
                checked={checked}
                loading={loading}
                onChange={handleChange}
              />
            </div>
          )
        },
      },
      {
        Header: "Action",
        accessor: "action",
        className: "iv_code",
        Cell: cellProps => (
          <div className="text-center d-flex justify-content-center">
            <a
              onClick={() =>
                navigate(
                  `${configure.appUrl}view-portfolio/${cellProps?.row?.original?.id}`
                )
              }
              className="btn btn-sm me-1 btn-outline-secondary"
              title="View Portfolio"
            >
              <i className="fas fa-eye"></i>
            </a>
            <a
              onClick={() =>
                navigate(
                  `${configure.appUrl}edit-portfolio/${cellProps?.row?.original?.id}`
                )
              }
              className="btn btn-sm me-1 btn-outline-secondary"
              title="Edit Portfolio"
            >
              <i className="fas fa-pencil-alt"></i>
            </a>
            <UncontrolledDropdown
              className="dropdown"
              style={{ width: "29px" }}
            >
              <DropdownToggle
                className="btn btn-sm btn-outline-secondary w-100"
                color="white"
              >
                <i className="mdi mdi-dots-horizontal"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <a
                  onClick={() =>
                    handleGenerateLink(cellProps?.row?.original?.generated_link)
                  }
                  className="btn text-dark dropdown-item"
                  title="Copy Link"
                >
                  <i className="bi bi-link fs-6 me-2"></i>
                  Copy Link
                </a>
                <a
                  onClick={() =>
                    onGetEvents(cellProps?.row?.original?.id)
                    // setIsEvent(true)
                  }
                  className="btn text-dark dropdown-item"
                  title="Copy Link"
                >
                  <i className="bx bx-info-circle fs-6 me-2"></i>
                  Event History
                </a>
                <a
                  onClick={() => ondelete(cellProps?.row?.original?.id)}
                  className="btn text-dark dropdown-item"
                  title="Delete Portfolio"
                >
                  <i className="bi bi-trash me-2"></i>
                  Delete
                </a>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        ),
      },
    ],
    []
  )


  console.log("allEvents", JSON.stringify(allEvents))

  return (
    <div>
      {isLoading && <Loader />}
      <React.Fragment>
        <div className="page-content" id="staff">
          <Container fluid>
            <Breadcrumb title={"Dashboard"} breadcrumbItem={"Portfolio"} />
            <Row>
              <Col lg={12} className="p-0">
                <Card>
                  <CardBody>
                    <div className="responsive-table">
                      <TableContainer
                        columns={columns}
                        data={datas}
                        setLoading={setLoading}
                        navigate={navigate}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>

      <div
        className={`note-sticky-form ${isEvent ? "d-block" : "d-none"}`}
      >
        <Draggable handle=".modal-header" cancel=".modal-body">
          <ResizableBox
            width={1100}
            style={{
              position: "fixed",
              top: "20%",
              right: "2%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header ">
              <h5 className="modal-title mt-0 text-purple">Portfolio Event History</h5>
              <div
                className="text-end"
                onClick={() => setIsEvent(false)}
              >
                <button className=" btn ms-md-0 btn-red ">
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </button>
              </div>
            </div>
            <Row className="align-items-center justify-content-between">
              <div className="col-md-3 d-flex justify-content-end align-items-center ps-3">
                <div className="text-center">
                  <img
                    src={editEventImg}
                    alt="Addepe"
                    style={{ width: "90%" }}
                  />
                </div>
              </div>
              <div className="col-9 d-flex flex-column justify-content-center align-items-start">

                <div className="w-100">
                  <div className=" mb-2 mt-4" style={{ maxHeight: '500px', overflow: 'auto', scrollbarWidth: 'thin' }}>
                    {/* <table className="table table-bordered mb-0 table " >
                      <thead className="bg-light" style={{ position: 'sticky', top: '0', left: '0', width: '100%' }}>
                        <tr>
                          <th className="text-center header ">
                            Name
                          </th>
                          <th className="text-center header ">
                            Email
                          </th>
                          <th className="text-center header ">
                            Event
                          </th>
                          <th className="text-center header">
                            Project / Service Name
                          </th>
                          <th className="text-center header ">
                            Website
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {allEvents?.map((obj, i) => {
                          return (
                            <tr key={i}>
                              <td className="text-center">
                                {obj?.name}
                              </td>
                              <td className="text-center">
                                {obj?.email}
                              </td>
                              <td className="text-center">
                                {obj?.type == 'service' ? "Service" : obj?.type == 'webiste' ? "Project Website" : 'Service Detail'}
                              </td>
                              <td className="text-center">
                                {obj?.type == 'service' ?
                                  caseStudies?.find(i => i.id == obj?.service_id)?.services || '--'
                                  :
                                  obj?.project_name}
                              </td>
                              <td className="text-center">
                                --
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table> */}

                    <UserTracking data={allEvents} caseStudies={caseStudies} />
                  </div>
                </div>
              </div>
            </Row>
          </ResizableBox>
        </Draggable>
      </div>
    </div>
  )
}

export default Portfolio
